import { ScoreCriteriaType } from "../schema/score.schema";

import { CellAssignment, PersonaView, SegmentView } from "./scoreConfigView";

type AssignmentOf = (segment: SegmentView, persona: PersonaView) => CellAssignment | null;

/**
 * The scorings with their cells as the page shows them: every segment x persona cell is given to
 * the scoring `assignmentOf` resolves it to, pending picks included. The issue engine reads cells
 * from `scoreCriteriaCompaniesPersonas`, which holds only what was saved — so right after a pick
 * it still said "not applied to any combination yet" beside the page's own "1 combination uses
 * this Lead Scoring" (PREC-4180).
 */
export const withPendingAssignments = (
	criteria: ScoreCriteriaType[],
	segments: SegmentView[],
	personas: PersonaView[],
	assignmentOf: AssignmentOf
): ScoreCriteriaType[] => {
	const cellsByScoring = new Map<number, ScoreCriteriaType["scoreCriteriaCompaniesPersonas"]>();

	for (const segment of segments) {
		for (const persona of personas) {
			const assignment = assignmentOf(segment, persona);

			if (!assignment) {
				continue;
			}

			const cells = cellsByScoring.get(assignment.criteriaId) ?? [];

			cells.push({
				id: assignment.ccpId,
				scoreCompanyCategoryId: segment.investorName ? null : segment.id,
				scorePersonaCategoryId: persona.id,
				investor: segment.investorName,
			});
			cellsByScoring.set(assignment.criteriaId, cells);
		}
	}

	return criteria.map((scoring) => ({
		...scoring,
		scoreCriteriaCompaniesPersonas: cellsByScoring.get(scoring.id) ?? [],
	}));
};
